import ko from 'knockout';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';

export default class AppealEditorViewModel {
  constructor({
    i18n,
    isForVNext = false,
  }) {
    if (isForVNext) {
      const schema = {
        properties: {
          justification: {
            type: 'string',
            required: true,
            maxLength: 1000,
          },
        },
      };

      koSchema.properties(this, schema, ['justification']);

      this.justification.validators.required.set({
        message: i18n.get('EditorialAppeal_JustificationRequired'),
      });
    } else {
      this.justification = ko.observable('');
    }

    this.appealed = ko.observable(true);
    this.appealedVisible = ko.observable(true);
    this.justificationPanelVisible = ko.observable(true);
  }
}
